import type { ApiClient } from './client';
export interface RewardTask {
  id: string;
  title: string;
  reward: number;
  progress: number | null;
  target: number;
  state: 'todo' | 'claim' | 'done' | 'claimed' | 'unavailable';
  tab: 'day' | 'week' | 'one' | 'fr';
  /** Что считает задание: works, circles, clones, story_shared, identity_linked… */
  metric?: string;
  available?: boolean;
  progress_available?: boolean;
  unavailable_reason?: string | null;
  action?: { kind: 'navigate' | 'story' | 'identity' | 'partner' | 'chat' | 'unsupported'; screen?: string; template_id?: string };
  period_key?: string;
  dev_only?: boolean;
  revision?: number;
}
export interface RewardsResponse {
  tasks: RewardTask[];
  streak: {
    day: number;
    today_claimed: boolean;
    days: number[];
    resets_at: string;
    consecutive?: number;
    current_amount?: number;
    next_amount?: number;
  };
  day_resets_at?: string;
  week_resets_at?: string;
  /** Только когда есть задания «Друзей» и сервер прочитал друзей с работой */
  friends?: { active: number; buyers: number } | null;
}
export interface RewardReceipt {
  amount?: number;
  operation_id?: string;
  day?: number;
  expires_at?: string | null;
  accepted?: boolean;
}
/** Тексты на картинке сторис на языке профиля (как на карточке): сервер кладёт их на картинку как есть */
export interface StoryTexts {
  title?: string;
  subtitle?: string;
  promo_label?: string;
  bonus_note?: string;
  discount_note?: string;
}
export interface StoryMaterial {
  media_url: string;
  share_proof: string;
  widget_link?: { url: string; name?: string };
  text?: string;
  expires_in: number;
}
export const rewards = (client: ApiClient) => ({
  get: (signal?: AbortSignal) => client.request<RewardsResponse>('/app/rewards', { signal }),
  claim: (task: string | null, key: string) =>
    client.request<RewardReceipt>(task ? `/app/rewards/tasks/${encodeURIComponent(task)}/claim` : '/app/rewards/streak/claim', {
      method: 'POST',
      idempotency: key,
    }),
  storyMaterial: (templateId: string, texts?: StoryTexts, signal?: AbortSignal) =>
    client.request<StoryMaterial>('/app/partner/materials/story', {
      method: 'POST',
      body: { template_id: templateId, ...texts },
      idempotency: true,
      signal,
    }),
  qr: (signal?: AbortSignal) => client.download('/app/partner/qr?theme=aurora', signal),
  shared: (task: string, templateId: string, proof: string, key: string) =>
    client.request<RewardReceipt>(`/app/rewards/tasks/${encodeURIComponent(task)}/shared`, {
      method: 'POST',
      body: { template_id: templateId, share_proof: proof },
      idempotency: key,
    }),
});
